import React from "react";
import { Layout, Row, Typography, Col, Card } from "antd";
import { Icon } from "@mdi/react";
import { mdiTwitter, mdiLinkedin, mdiFacebook, mdiInstagram, mdiGithub } from "@mdi/js";
import NavBar from "components/nav-bar";
import "./team.less";
import teamData from "data/team.json";
import pattern from "assets/pattern.svg";
import { FooterBar } from "components/footer";

class Team extends React.Component {
  render() {
    return (
      <Layout className='page--team'>
        <NavBar />
        <Row className='content__container'>
          <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}>
            <div className='pattern-background' style={{backgroundImage: `linear-gradient(to right, rgba(16, 11, 2, 0.88), rgba(16, 11, 2, 1)), url(${pattern})`}} />
          </Col>

          <Col xs={22} sm={22} md={20} lg={18} xl={16} xxl={14}>
            <Row>
              <Typography.Title className='content__title'>Who we are</Typography.Title>
            </Row>

            <Row>
              <Typography.Text className='team__description'>{teamData.description}</Typography.Text>
            </Row>

            <Row>
              <Typography.Title level={3} className='team-group__title'>{teamData.researchTeamName}</Typography.Title>
            </Row>

            <Row gutter={[20, 20]}>
              {this.teamMembers('RESEARCH')}
            </Row>

            <Row>
              <Typography.Title level={3} className='team-group__title'>{teamData.techTeamName}</Typography.Title>
            </Row>

            <Row gutter={[20, 20]}>
              {this.teamMembers('TECH')}
            </Row>
          </Col>
          <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}>
            <div className='pattern-background' style={{backgroundImage: `linear-gradient(to left, rgba(16, 11, 2, 0.88), rgba(16, 11, 2, 1)), url(${pattern})`}} />
          </Col>
        </Row>

        <FooterBar />
      </Layout>
    );
  }

  private teamMembers(group: string): JSX.Element[] {
    let teamCards: JSX.Element[] = [];
    for(let teamMember of teamData.members.sort((a, b) => a.name.localeCompare(b.name))) {
      if(teamMember.team === group) {
        teamCards.push(
          <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8} key={teamMember.name}>
            <Card className='team-member__card'>
              <img src={require(`data/team/${teamMember.photo || 'nopic.svg'}`)} className='team-member__photo' alt='' />
              <Typography.Title level={4} className='team-member__name'>{teamMember.name}</Typography.Title>
              <Typography.Text className='team-member__description'>{teamMember.description ?? ''}</Typography.Text>
              {this.generateSocialLink(teamMember.social)}
            </Card>
          </Col>
        );
      }
    }
    return teamCards;
  }

  private generateSocialLink(social: {name: string; site: string; link: string} | undefined): JSX.Element {
    if(social) {
      let icon = mdiTwitter;
      switch(social.site) {
        case 'linkedin': icon = mdiLinkedin; break;
        case 'facebook': icon = mdiFacebook; break;
        case 'instagram': icon = mdiInstagram; break;
        case 'github': icon = mdiGithub; break;
        default: break;
      }
      return (
        <a
        className='team-member__social'
        href={social.link}
        target="_blank"
        rel="noopener noreferrer"
        ><Icon path={icon} />{social.name}</a>
      );
    } else {
      return <></>;
    }
  }
}

export default Team;
